import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  CsvExport,
  FilterButton,
  CreateButton,
  ActionButton,
} from "../../UiElement";

/**
 * ListingHeader component represents the header section of a listing page.
 * It includes buttons for filtering, exporting CSV, creating new items, and additional custom actions.
 *
 * @component
 * @param {Object} props - Props for the component.
 * @param {string} props.btnText - Text for the CreateButton.
 * @param {string[]} props.btnArray - Array of button types to include.
 * @param {Function} props.onHandleShow - Handler for showing the CreateButton modal.
 * @param {Object} props.popover - Popover configuration for the FilterButton.
 * @param {string} props.extraBtnText - Text for the additional ActionButton.
 * @param {string} props.extraBtnClass - Additional class for the ActionButton.
 * @param {string} props.extraBtnIconClass - Icon class for the ActionButton.
 * @param {Function} props.onExtraButtonHandleShow - Handler for showing the additional ActionButton modal.
 * @param {Object} props.icon - Icon for the CreateButton.
 * @param {Function} props.setVisible - Function to set the visibility state.
 * @param {boolean} props.visible - Visibility state for the FilterButton popover.
 * @returns {JSX.Element} JSX.Element representing the ListingHeader component.
 */
function ListingHeader({
  btnText,
  btnArray,
  onHandleShow,
  popover,
  extraBtnText,
  extraBtnClass,
  extraBtnIconClass,
  onExtraButtonHandleShow,
  icon,
  setVisible,
  visible,
}) {
  const [filterToggle, setFilterToggle] = useState(false);
  return (
    <>
      <div className="nk-block-head-content">
        <div className="toggle-wrap nk-block-tools-toggle">
          <Link
            to="#"
            className="btn btn-icon btn-trigger toggle-expand mr-n1"
            data-target="more-options"
            onClick={() => setFilterToggle(!filterToggle)}
          >
            <em className="icon ni ni-more-v" />
          </Link>
          <div
            className={`toggle-expand-content ${
              filterToggle ? "expanded" : ""
            }`}
            data-content="more-options"
          >
            <ul className="nk-block-tools g-3 ">
              {btnArray.includes("filter") && (
                <li>
                  <FilterButton
                    className="bg-black border-transparent"
                    popover={popover}
                    setVisible={setVisible}
                    visible={visible}
                  />
                </li>
              )}
              {btnArray.includes("csvExport") && (
                <li>
                  <CsvExport
                    extraClassName={`btn btn-white btn-outline-light `}
                  >
                    <em className="icon ni ni-download-cloud" />
                    <span> Export CSV </span>
                  </CsvExport>
                </li>
              )}
              {btnArray.includes("create") && (
                <li className="nk-block-tools-opt">
                  <CreateButton
                    icon={icon}
                    onHandleShow={onHandleShow}
                    btnText={btnText}
                  />
                </li>
              )}
              {btnArray.includes("extraButton") && (
                <li className="nk-block-tools-opt">
                  <ActionButton
                    extraBtnClass={extraBtnClass}
                    onHandleAction={onExtraButtonHandleShow}
                    btnText={extraBtnText}
                    icon={extraBtnIconClass}
                  />
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default ListingHeader;
